module.exports = __webpack_public_path__ + "img/CollateralList2.6733503f.svg";